<h1 translate="send-conversation-by-email/title"></h1>

<ion-content>
  <p>
    <span translate="send-conversation-by-email/intro-1"></span><br />
    <ng-container *ngIf="settings.replyToEmailMode !== replyToEmailModeEnum.none">
      <span
        [translate]="'send-conversation-by-email/intro-2-' + settings.replyToEmailMode"
        [translateParams]="{ email: replyToEmail }"></span
      ><br />
    </ng-container>
    <span class="error" translate="send-conversation-by-email/intro-3"></span>
  </p>
  <form [formGroup]="form">
    <!-- recipients -->
    <div>
      <mat-form-field appearance="outline">
        <mat-label><span translate="send-conversation-by-email/recipients"></span> *</mat-label>
        <mat-chip-list #chipList>
          <mat-chip
            *ngFor="let recipient of form.value.recipients"
            [disabled]="recipient.default"
            (removed)="removeRecipient(recipient)">
            {{ recipient.email }}
            <button matChipRemove *ngIf="!recipient.default">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            formControlName="recipient"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addRecipient($event)" />
        </mat-chip-list>
        <mat-hint translate="send-conversation-by-email/recipients/hint"></mat-hint>
        <mat-error
          *ngIf="chipList.errorState && this.recipientError === recipientErrorEnum.required"
          translate="common/form_errors/required"></mat-error>
        <mat-error
          *ngIf="chipList.errorState && this.recipientError === recipientErrorEnum.invalidEmail"
          translate="common/form_errors/invalid-email"></mat-error>
        <mat-error
          *ngIf="chipList.errorState && this.recipientError === recipientErrorEnum.exists"
          translate="send-conversation-by-email/recipient-error/exists"></mat-error>
        <mat-error
          *ngIf="chipList.errorState && this.recipientError === recipientErrorEnum.domain"
          translate="send-conversation-by-email/recipient-error/domain"
          [translateParams]="{ domains: authorizedDomains }"></mat-error>
      </mat-form-field>
    </div>

    <!-- object -->
    <div>
      <mat-form-field appearance="outline">
        <mat-label translate="send-conversation-by-email/object"></mat-label>
        <input matInput formControlName="object" />
        <mat-error *ngIf="form.controls.object.errors?.required" translate="common/form_errors/required"></mat-error>
        <mat-hint translate="send-conversation-by-email/user-replacement-hint"></mat-hint>
      </mat-form-field>
    </div>

    <!-- comment -->
    <div>
      <mat-form-field appearance="outline">
        <mat-label translate="send-conversation-by-email/comment"></mat-label>
        <textarea matInput formControlName="comment" cdkTextareaAutosize></textarea>
        <mat-error *ngIf="form.controls.comment.errors?.required" translate="common/form_errors/required"></mat-error>
        <mat-hint translate="send-conversation-by-email/user-replacement-hint"></mat-hint>
      </mat-form-field>
    </div>
  </form>

  <!-- preview -->
  <h2 translate="send-conversation-by-email/preview"></h2>
  <div class="preview">
    <p [innerHTML]="preview"></p>
  </div>
</ion-content>

<ion-footer class="footer">
  <ion-button (click)="sendEmail()" [disabled]="form.invalid"
    ><span translate="send-conversation-by-email/send"></span
  ></ion-button>
  <ion-button (click)="closeModal()" fill="outline"><span translate="cancel"></span></ion-button>
  <ion-button (click)="minimizeModal()" fill="outline" class="minimize"><span translate="minimize"></span></ion-button>
</ion-footer>
